module.exports = __webpack_public_path__ + "media/application/images/svgs/sliders-b863b16f981e6bdd2a8b06aaf1ee15a8.svg";